<template>
    <div class="home">
      <TopNavigation :dialogVisibleLogin="dialogVisibleLogin" @message="getdialogVisibleLogin"  class="topNavigation"></TopNavigation>

        <div class="header">
            <!-- <video class="video" :src="videoSource" controlsd autoplay muted loop></video> -->
            <img class="headerImg" src="@/assets/images/hpcopy/header.png" alt="">
        </div>
        <div class="content ">
            <FreightRate @message="loginDialog" class="typeArea" :dialogVisibleLoginER="dialogVisibleLoginER" />


            
            <!-- 小喇叭 -->
            <div class="typeArea">
                <div  class="horn">
                    <img src="../../assets/images/hpcopy/laba.png"/>
                    <!-- <marquee  scrollamount="1" direction="up">
                        用户******在30分钟之前下单
                    </marquee> -->
                    <!-- <vue-seamless-scroll
                      :data="msgList"
                      :class-option="classOption"
                      class="warp"
                    >
                      <div v-for="(item, index) in msgList" :key="index">
                        <span class="title" v-text="item.user"></span>
                        <span class="di"  v-text="item.port"></span>
                      </div>
                    </vue-seamless-scroll> -->
                    <el-carousel 
                    class="warp"
                      direction="vertical" 
                      indicator-position="none"
                      autoplay>
                        <el-carousel-item v-for="(item, index) in msgList" :key="index">
                          <span class="title" v-text="item.user"></span>
                          <span class="di"  v-text="item.port"></span>
                        </el-carousel-item>
                      </el-carousel>
                </div>
            </div>
            <!-- 线 -->
            <!-- <div class="line"></div> -->

            <!-- 精选运价 -->
            <Freight class="xiancangshic" />
            
            <!-- 现舱市场 -->
            <Marketplace class="xiancangshic" />

            <!-- 全程贴心服务 -->
            <div class="service">
                <div class="xiantiao"></div>
                <div class="qctx">
                <div class="qc_con">
                    <p class="qc_tit">全程贴心服务与您同在</p>
                    <p class="qc_word">订好舱集成主流船东电商和一手庄家舱位的在线服务平台</p>
                </div>
                </div>
                <div v-for="(item,index) in jingXuanList" :key="index" class="qctx_con" 
                :class="{'qctx_con_hover': onwrap == index}"  
                @mouseenter="projectin(index)"
                @mouseleave="projectout(index)"
                @click="quancheng(item.id, item.url)">
                    <p class="qc_tit">{{item.title}}</p>
                    <p class="qc_xian qctx_con_word"></p>
                    <p class="qctx_con_word">{{item.word}}</p>
                </div>
            </div>

            <!-- 地图地图 -->
            <div class="ditu">
              <div class="map typeArea">
                  <Animation class="map_tit" :message="qq_parentMessage" />
                  <!-- <p>全球热门港口</p> -->
                  <!-- <img src="../../assets/images/热门港口.png" /> -->
                  <MapPage />
              </div>
            </div>

            <!-- 码头箱动态 -->
            <PortContainer />

            <!-- 相关信息 -->
            <div class="information">
              <div class="information_tit">航司信息</div>
              <div class="information_tit_v">点击跳转到船司官网</div>
              <div class="ship">
                  <div class="shipson" v-for="(item,index) in shippingList.slice(0, 10)" :key="index">
                    <a :href="item.url" target="_blank" v-if="item.url!=''"> 
                      <img :src="item.cover" />
                    </a>
                    <div v-else>
                      <img :src="item.cover" />
                    </div>
                  </div>
              </div>

              <!-- <p class="information_btn">
                  <el-button @click="chaKanShip">查看更多</el-button>
              </p> -->
            </div>
            <Bottom />

            
        </div>
    </div>
</template>

<!-- WPA start -->
<!-- <script id="qd3009079785252efa856fc49c7cf37e317449fc4369" src="https://wp.qiye.qq.com/qidian/3009079785/252efa856fc49c7cf37e317449fc4369" charset="utf-8" async defer></script> -->
<!-- WPA end -->

<script>
// 导航
import TopNavigation from "./TopNavigation.vue";
// 精选运价
import FreightRate from "./FreightRate.vue";
// 现舱市场
import Marketplace from "./MarketplacePage.vue";
// 地图
import MapPage from './MapYemian.vue';
// 码头箱动态
import PortContainer from './PortContainerPage.vue';
// 动态字体
import Animation from './AnimationPage.vue';
// 底部
import Bottom from './BottomPage.vue';
// 精选运价
import Freight from './FreightRatePage';


import { baseShippingCompanyValidList,unReadNum,recentlyDynamics } from "@/api/api";
export default {
    components:{
        FreightRate,
        TopNavigation,
        Marketplace,
        MapPage,
        PortContainer,
        Animation,
        Bottom,
        Freight,
    },
    data(){
        return{
            // 视频
            videoSource: "",
            // 精选运价列表数据
            jingXuanList:[
                {
                  id:1,
                  title:'精选运价',
                  word:'精选全国各大口岸超百家多航线实力庄家入驻，运价实时更新，你没有必要花精力满世界去寻找价格，轻点鼠标你就能得到你想要的。。。',
                  url:'/SelectedFreightRates',
                },
                {
                  id:2,
                  title:'现舱市场',
                  word:'当你手上有多余的舱位为找不到客户而发愁，订好舱为你提供了现舱超市，只要你轻点鼠标，就能获得你想要的客户及仓位供应。。。',
                  url:'/Market',
                },
                {
                  id:3,
                  title:'船东SPOT',
                  word:'近10家一线船东的在线价格查询下单，订好舱提供最新的时时价格，船期，舱位和价格明细。。。',
                  url:'/ShipSPOT',
                },
                {
                  id:4,
                  title:'美加到门',
                  word:'专业美加后端到门服务，你只有输入一个美加邮编地址，余下交给专业的团队，我们给你提供最优的路径和优惠的价格，让美加到门报价不再等待。。。',
                  url:'/USToDoor',
                }
            ],
            onwrap:1,
            // 全球热门港口标题
            qq_parentMessage:{
                title:'全球热门港口',
                content:'覆盖核心航线，掌握全球港口动态'
            },
            // 公司logo列表数据
            shippingList:[],
            // 小喇叭
            msgList:[],
            classOption: {
              singleHeight: 30,
              limitMoveNum:1,
              waitTime:2000,
            },
            dialogVisibleLogin:false,
            dialogVisibleLoginER:true,
        }
    },
    setup() {
        
    },
    mounted(){
      this.getShippingList()
      this.getUnReadNum()
      this.getlabaList()
        // 视频路径
        this.videoSource = 'https://video.qmszts.cn/asset/3fb5d895b6a775a63b46028ddfb2f6db/2b1a0614106ebbd85a40f50d329513de.mp4';

        // 创建一个标签来存放QQ
        // const script= document.createElement('script');
        // script.id = 'qd3009079785252efa856fc49c7cf37e317449fc4369';
        // script.type = 'text/javascript';
        // script.src = `https://wp.qiye.qq.com/qidian/3009079785/252efa856fc49c7cf37e317449fc4369`;
        // document.body.appendChild(script);
    },
    methods:{
      // 接收父子传值
      loginDialog(data) {
        this.dialogVisibleLogin = data.dialogVisibleLogin;
      },
      getdialogVisibleLogin(data){
        this.dialogVisibleLoginER = data.dialogVisibleLoginER;
        this.dialogVisibleLogin = data.dialogVisibleLoginER;
      },
        projectin(index) {
            this.onwrap = index
        },
        // 鼠标移出事件，smallwrapCss失效，所有元素恢复defaultCss
        projectout(index) {
          this.onwrap = index
        },
        // 船公司
        async getShippingList() {
          const res = await baseShippingCompanyValidList();
          if (res.code == 1) {
            this.shippingList = res.data;
          }
        },
        chaKanShip(){
          this.$router.push({
            name:'Tool',
            params:{
              menuInx:'2',
            }
          })
        },
        // 调用接口  获取未读数量
        async getUnReadNum(){
          try {
            const res = await unReadNum({token:localStorage.getItem('token')})
            let storedObject = localStorage.getItem('userInfo');
            if (storedObject) { 
              let obj = JSON.parse(storedObject);
              obj.unread_num = res.data.unread_num;
              localStorage.setItem('userInfo', JSON.stringify(obj)); // 重新存储对象
            }      
          } catch (error) {
            console.log(error,'失败');
          }
        },
        quancheng(index, url) {
          sessionStorage.setItem("lineIndex", index);
          if (!localStorage.getItem('isLogin')) {
            // 判断是否登录 没有登录弹出登录对话框
            this.dialogVisibleLogin = true;
          } else {
            if (this.$route.path != url) {
              this.$router.push(url);
            } else {
              window.scrollTo(0, 0);
            }
            this.highlightedIndex = index;
          }
        },
        async getlabaList(){
          try {
            const res = await recentlyDynamics()
            this.msgList = [...res.data]
            for (let i = 0; i < this.msgList.length; i++) {
              this.msgList[i].id=i
            }

          } catch (error) {
            console.log(error,'失败');
          }
        }
    },
}
</script>

<style lang="scss" scoped>
body {
    font-size: 16px;
}

.home{
  position: relative;
  width: 100%;
  height: 100%;
}

// .video {
//     width: 100% ;
//     height: 900px;
//     object-fit: fill;
// }

// 版心
.typeArea{
    width: 1776px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
}

.content{
    // width: 1200px;
    width: 100%;
    // position: absolute;
    // top: 820px;
    // left: 50%;
    // transform: translate(-50%);
    margin: 0 auto;
    // border-radius: 12px;
}

.header{
  margin-top: 100PX;
    width: 100%;
    .headerImg{
      width: 100%;
      height: 840px;
    }
}
.topNavigation{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 100PX;
    display: flex;
    justify-content: space-between;
    padding: 0 80px;
    // z-index: 9999;
    background: #fff;
}

.horn{
    display: flex;
    align-items: center;
    flex-direction: row;
    background: #F6F8FC;
    border-radius: 0px 0px 11px 11px;
    box-shadow: 0px 20px 31px 0px rgba(12,48,88,0.08);
    margin-bottom: 120px;
    padding-left: 32px;
    img{
        margin: 20px 0;
        margin-right: 10px;
        width: 20px;
        height: 20px;
    }

    .warp{
      height: 30px;
      width: 100%;
      overflow: hidden;

      .title{
        height: 30px;
        line-height: 30px;
        color: #424F62;
        font-size: 14px;
      }

      .di{
        color: #1D3A66;
        font-size: 14px;
        margin-left: 8px;
        font-weight: 500;
      }
    }
}

.xiancangshic{
  background: #fff;
}

.line{
    content: "";
    width: 100%;
    height: 1px;
    background-color: #E4E7ED;
    z-index: 1;
}

.service{
    position: relative;
    width: 100%;
    height: 640px;
    background-image:url('../../assets/images/hpcopy/背景明.png');	
    background-repeat: no-repeat;
    background-size:100% 100%;
    display:flex;
    align-items: center;
    overflow: hidden;
    color: #fff;
    // .xiantiao{
    //   height: 100%;
    //   width: 1px;
    //   background: #fff;
    //   position: absolute;
    //   top: 0;
    //   left: 63px;
    // }
    .qctx{
        width: 637px;
        height: 100%;
        border-right: 1px solid rgba(255, 255, 255, 0.36);
        .qc_con{
            width: 80%;
            height: 67px;
            font-family: PingFang SC, PingFang SC;
            color: #FFFFFF;
            text-align: left;
            font-style: normal;
            text-transform: none;
            margin-top: 160px;
            margin-left: 60px;
            .qc_tit{
                width: 480px;
                font-size: 48px;
                font-weight: bold;
            }
            .qc_word{
              width: 420px;
              font-size: 24px;
            }
        }
    }
    .qctx_con{
      cursor: pointer;
      width: 273px;
      height: 640px;
      // width: 18%;
      border-right: 1px solid rgba(255, 255, 255, 0.36);
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      transition: width 0.5s ease-in-out;
      .qctx_con_word{
        display: none;
        padding: 0 25px;
        width: 360px;
        opacity: 0;
        transition: width 0.5s ease-in-out,opacity 0.5 ease-in-out;
      }
      .qc_tit{
        font-size: 28px;
      }
      .qc_xian{
        content: "";
        width: 32px;
        height: 4px;
        background: rgba(255, 255, 255, 0.36);
        z-index: 1;
      }
    }
    .qctx_con:last-child{
      border-right: 0px;
    }
    
    .qctx_con_hover{
      // width: 25%;
      // background: #1347B0;
      // opacity: 0.8;
      width: 460px;
      height: 640px;
      background: #1347B0;
      border-radius: 0px 0px 0px 0px;
      transition: width 0.5s ease-in-out,;
      opacity: 0.8;
      .qctx_con_word{
        display: inline-block;
        opacity: 1;
        font-size: 16px;
        transition: width 0.5s ease-in-out,opacity 0.5 ease-in-out;
      }
    }
}

.ditu{
  background: #fff;
}
.map{
  text-align: center;
  padding-bottom: 150px;
  .map_tit{
    margin-top: 150px;
    margin-bottom: 87px;
  }
  p{
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 32px;
    color: #000000;
    line-height: 38px;
    font-style: normal;
    text-transform: none;
  }
  img{
    width: 100%;
  }
}

// 相关信息  下方内容
.information{
  width: 100%;
  height: 732px;
  background-image:url('../../assets/images/hpcopy/bottomBj.png');	
  background-repeat: no-repeat;
  background-size:100% 100%;
  // margin-top: 0px;

  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  font-style: normal;
  text-transform: none;
    
  .information_tit{
    font-size: 32px;
    line-height: 38px;
    text-align: center;
    padding-top: 150px;
    margin-bottom: 8px;
  }

  .information_tit_v{
    font-size: 20px;
    line-height: 28px;
    text-align: center;
    margin-top: 12px;
    margin-bottom: 60px;
    color: #DADDE8;
  }

  .ship{
    width: 68%;
    display: flex;
    margin: 0 auto;
    flex-wrap: wrap;
    // justify-content: center;
    .shipson{
      width: 20%;
    }
    a{
      width: 100%;
      height: 100%;
      display: inline-block;
    }
    img{
      margin: 5px;
      width: 250px;
      height: 110px;
      background: #FFFFFF;
      border-radius: 4px;
    }
  }
  .information_btn{
    text-align: center;
    padding: 60px 0px 40px;
    margin: 0px;
    .el-button{
      font-size: 16px;
      span{
        font-size: 16px;
      }
    }
  }
  .el-button{
    width: 180px;
    height: 48px;
    background: rgb(255  255 255 / 0.3);
    border-radius: 80px 80px 80px 80px;
    color: #fff;
  }
}
</style>